<template>
  <main role="main">
    <div class="container-fluid no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-8 mb-2 mt-2">
          <input class="form-control w-75 float-left btn-more-radius mr-2" @keyup.enter="getMalzemeler()" v-model="searchFilter"
            type="text" placeholder="Stok kodu, malzeme türü ve ya malzeme adı ile arama yapın...">
          <div class="dropdown float-left">
            <button class="btn btn-outline-primary btn-more-radius dropdown-toggle" type="button"
              id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Kolon Seçenekleri
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <div class="dropdown-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="colOps_ManCode" v-model="columnOptions.MALZEME_MANCODE">
                  <label class="custom-control-label font-weight-normal" for="colOps_ManCode">ÜRETİCİ ve ÜRETİCİ KODU</label>
                </div>
              </div>
              <div class="dropdown-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="colOps_Supplier" v-model="columnOptions.MALZEME_SUPPLIER">
                  <label class="custom-control-label font-weight-normal" for="colOps_Supplier">ÜRÜN SAĞLAYICI</label>
                </div>
              </div>
              <div class="dropdown-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="colOps_UnitPrice" v-model="columnOptions.MALZEME_UNIT_PRICE">
                  <label class="custom-control-label font-weight-normal" for="colOps_UnitPrice">BİRİM FİYAT</label>
                </div>
              </div>
              <div class="dropdown-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="colOps_Note" v-model="columnOptions.MALZEME_NOTE">
                  <label class="custom-control-label font-weight-normal" for="colOps_Note">MALZEME NOTU</label>
                </div>
              </div>
              <div class="dropdown-item">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="colOps_Creator" v-model="columnOptions.MALZEME_CREATOR">
                  <label class="custom-control-label font-weight-normal" for="colOps_Creator">OLUŞTURAN ve OLUŞTURMA ZAMANI</label>
                </div>
              </div>
              <!--<div class="dropdown-item align-middle">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" v-model="columnOptions.MALZEME_MANUFACTURER" id="customCheck1">
                  <label class="custom-control-label font-weight-normal" for="customCheck1">ÜRETİCİ</label>
                </div>
              </div>-->
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-2 mt-2">
          <button class="btn btn-more-radius btn-success float-right" data-toggle="modal"
            @click="openModalForInsertUpdate(0, 0)" data-target="#addMalzemeModal"
            v-if="canAddStok">Yeni Malzeme Oluştur</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="malzemeler-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Malzemeler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-hover">
              <thead>
                <tr class="thead-light">
                  <th style="width: 10%;" scope="col">STOK KODU</th>
                  <th style="min-width: 25%;" scope="col">ÜRÜN BİLGİSİ</th>
                  <th style="max-width: 6%;" class="text-center" scope="col">LENOİ STOK</th>
                  <th style="max-width: 6%;" class="text-center" scope="col">FABRİKA STOK</th>
                  <th style="max-width: 6%;" class="text-center" scope="col">Ü.M.E. STOK</th>
                  <th v-if="columnOptions.MALZEME_UNIT_PRICE" style="max-width: 6%;" scope="col">BİRİM FİYAT</th>
                  <th v-if="columnOptions.MALZEME_MANUFACTURER || columnOptions.MALZEME_MANCODE"
                    style="width: 10%;" scope="col">ÜRETİCİ</th>
                  <th v-if="columnOptions.MALZEME_SUPPLIER" style="width: 10%;" scope="col">SAĞLAYICI</th>
                  <th v-if="columnOptions.MALZEME_CREATOR" style="width: 10%;" scope="col">OLUŞTURAN</th>
                  <th v-if="columnOptions.MALZEME_NOTE" style="min-width: 25%;" scope="col">MALZEME NOTU</th>
                  <th scope="col" class="text-center">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <tr v-for="(malzeme, index) in malzemeler" :key="malzeme.MALZEME_CODE">
                  <th class="align-middle" scope="row">{{malzeme.MALZEME_CODE}}</th>
                  <td class="align-middle">
                    <div>
                      <p class="my-0">{{malzeme.MALZEME_NAME}}</p>
                      <small class="text-primary">{{malzeme.MALZEME_TYPE}}</small>
                      <small class="text-secondary">{{malzeme.MALZEME_DETAIL}}</small>
                      <div class="" v-if="malzeme.IN_USED_PRODUCTS">
                        <span v-for="(inused, iuIndex) in malzeme.IN_USED_PRODUCTS.split(',')"
                          v-bind:key="'inused-' + iuIndex"
                          class="badge font-light badge-pill badge-primary mr-1">{{inused}}</span>
                      </div>
                    </div>
                  </td>
                  <td class="text-center align-middle font-weight-bold">{{malzeme.MALZEME_LENOI}}</td>
                  <td class="text-center align-middle">{{malzeme.MALZEME_FABRIKA}}</td>
                  <td class="text-center align-middle">{{malzeme.MALZEME_URUNMONTAJ}}</td>
                  <td v-if="columnOptions.MALZEME_UNIT_PRICE" class="align-middle">{{malzeme.MALZEME_UNIT_PRICE}}</td>
                  <td v-if="columnOptions.MALZEME_MANUFACTURER || columnOptions.MALZEME_MANCODE" class="align-middle">
                    <div>
                      <p class="my-0">{{malzeme.MALZEME_MANUFACTURER || '-'}}</p>
                      <small class="text-danger">{{malzeme.MALZEME_MANCODE}}</small>
                    </div>
                  </td>
                  <td v-if="columnOptions.MALZEME_SUPPLIER" class="align-middle">{{malzeme.MALZEME_SUPPLIER}}</td>
                  <td v-if="columnOptions.MALZEME_CREATOR || columnOptions.MALZEME_CREATED" class="align-middle">
                    <div>
                      <p class="my-0">{{malzeme.PERSONEL_NAME}}</p>
                      <small class="text-muted">{{malzeme.MALZEME_CREATED_FORMATTED}}</small>
                    </div>
                  </td>
                  <td v-if="columnOptions.MALZEME_NOTE" class="align-middle">
                    <span :data-toggle2="malzeme.MALZEME_NOTE != undefined && malzeme.MALZEME_NOTE.length > 40 ? 'tooltip' : ''"
                      data-placement="bottom" :title="malzeme.MALZEME_NOTE">{{formatNote(malzeme.MALZEME_NOTE)}}</span>
                  </td>
                  <td class="text-center align-middle">
                    <div class="btn-group">
                      <button class="btn btn-outline-primary btn-more-radius dropdown-toggle"
                        type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Malzeme İşlemleri
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <h6 class="dropdown-header">Giriş - Çıkış</h6>
                        <a role="button" class="dropdown-item" :disabled="!canAddStok"
                          data-toggle="modal" data-target="#addStokModal"
                          @click="selectMalzeme(malzeme.MALZEME_ID, index)">
                          <i class="fas fa-plus-circle"></i>&nbsp;&nbsp;&nbsp;Stok Girişi Yap</a>
                        <a role="button" class="dropdown-item" :disabled="!canSpendStok"
                          data-toggle="modal" data-target="#exportFabrikaModal"
                          @click="selectMalzeme(malzeme.MALZEME_ID, index)">
                          <i class="fas fa-house-damage"></i>&nbsp;&nbsp;&nbsp;Fabrikaya Çıkış Yap</a>
                        <a role="button" class="dropdown-item" :disabled="!canSpendStok"
                          data-toggle="modal" data-target="#exportUmeModal" @click="selectMalzeme(malzeme.MALZEME_ID, index)">
                          <i class="fas fa-cubes"></i>&nbsp;&nbsp;&nbsp;Ürün Montaja Çıkış Yap</a>
                        <router-link role="button" class="dropdown-item" to="/stok/seri-numaralar"
                          v-if="canAddSerialNumberToMalzeme && malzeme.MALZEME_HAS_SERIAL">
                          <i class="fas fa-barcode"></i>&nbsp;&nbsp;&nbsp;Seri Numarası Gir</router-link>
                        <div class="dropdown-divider"></div>
                        <h6 class="dropdown-header">Diğer İşlemler</h6>
                        <a role="button" class="dropdown-item" :disabled="!canAddStok"
                          data-toggle="modal" data-target="#addMalzemeModal" @click="openModalForInsertUpdate(1, index)">
                          <i class="fas fa-edit"></i>&nbsp;&nbsp;Düzenle
                        </a>
                        <a role="button" class="dropdown-item" :disabled="!canReadMessage"
                          data-toggle="modal" data-target="#conversationModal" @click="openMalzemeMesajlari(malzeme.MALZEME_ID, index)">
                          <i class="fas fa-comments"></i>&nbsp;&nbsp;İşlem Geçmişini Göster
                        </a>
                        <a role="button" class="dropdown-item text-danger" :disabled="!canDeleteStok"
                          data-toggle="modal" data-target="#deleteMalzemeModal" @click="askDelete(malzeme.MALZEME_ID, index)">
                          <i class="fas fa-trash-alt text-danger"></i>&nbsp;&nbsp;&nbsp;Malzemeyi Sil
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div v-if="canAddStok" class="modal fade bd-example-modal-lg" id="addMalzemeModal" tabindex="-1"
      role="dialog" aria-labelledby="addMalzemeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">
              {{openModalFor == 0 ? 'Yeni Malzeme Oluştur' : 'Malzemeyi Düzenle'}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body bg-fluent">
            <v-wait for="malzeme-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Malzeme Kaydediliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-kod">Stok Kodu</label>
                    <input type="text" class="form-control" v-model="selectedMalzeme.MALZEME_CODE" id="malzeme-kod">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-tur">Ürün Türü</label>
                    <input type="text" class="form-control" v-model="selectedMalzeme.MALZEME_TYPE" id="malzeme-tur">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-adi">Ürün Adı</label>
                    <input type="text" class="form-control" v-model="selectedMalzeme.MALZEME_NAME" id="malzeme-adi">
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12 mb-3">
                    <label for="malzeme-detail">Açıklama</label>
                    <input type="text" class="form-control" rows="4" id="malzeme-detail" v-model="selectedMalzeme.MALZEME_DETAIL" />
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-3">
                    <label for="malzeme-supplier">Ürün Sağlayıcı</label>
                    <input type="text" class="form-control" id="malzeme-supplier" v-model="selectedMalzeme.MALZEME_SUPPLIER" />
                  </div>
                  <div class="col-md-3">
                    <label for="malzeme-detail">Üretici</label>
                    <input type="text" class="form-control" rows="4" id="malzeme-manufacturer" v-model="selectedMalzeme.MALZEME_MANUFACTURER" />
                  </div>
                  <div class="col-md-3">
                    <label for="malzeme-mancode">Üretici Kodu</label>
                    <input type="text" class="form-control" rows="4" id="malzeme-mancode" v-model="selectedMalzeme.MALZEME_MANCODE" />
                  </div>
                  <div class="col-md-3">
                    <label for="malzeme-mancode">Birim Fiyatı</label>
                    <input type="text" class="form-control" rows="4" id="malzeme-mancode" v-model="selectedMalzeme.MALZEME_UNIT_PRICE" />
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-12 mb-5">
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input type="checkbox" id="malzeme-consumable" class="custom-control-input" v-model="selectedMalzeme.MALZEME_CONSUMABLE">
                      <label class="custom-control-label light-text" for="malzeme-consumable">Bu bir sarf malzemesidir.</label>
                      <small id="malzeme-consumable" class="form-text text-muted">Bu seçeneği işaretlediğinizde bu malzeme, ürün çıkış sayfasında görüntülenebilir ve müşteriye çıkışı yapılabilir.</small>
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-12 mb-5">
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input type="checkbox" id="malzeme-has-serial" class="custom-control-input" v-model="selectedMalzeme.MALZEME_HAS_SERIAL">
                      <label class="custom-control-label light-text" for="malzeme-has-serial">Bu malzeme seri numarasına sahiptir.</label>
                      <small id="malzeme-consumable" class="form-text text-muted">Bu seçeneği işaretlediğinizde bu malzeme için seri numarası girişi aktif edilir. Girilen seri numaraları, ürün çıkışı yapıldığında stoktan çıkılmış olarak işaretlenir.</small>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="openModalFor==0">
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-lenoi-stok">Lenoi Stok</label>
                    <input type="text" class="form-control" id="malzeme-lenoi-stok" v-model="selectedMalzeme.MALZEME_LENOI" />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-detail">Fabrika Stok</label>
                    <input type="text" class="form-control" id="malzeme-manufacturer" v-model="selectedMalzeme.MALZEME_FABRIKA" />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-mancode">Ürün Montaj Stok</label>
                    <input type="text" class="form-control" id="malzeme-mancode" v-model="selectedMalzeme.MALZEME_URUNMONTAJ" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="malzeme-note">Ürün Notu</label>
                    <textarea type="text" class="form-control" rows="3" id="malzeme-mancode" v-model="selectedMalzeme.MALZEME_NOTE" />
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="insertMalzeme()" class="btn btn-primary">Malzeme Kaydını Tamamla</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canAddStok" class="modal fade bd-example-modal-lg" id="addStokModal" tabindex="-1"
      role="dialog" aria-labelledby="addStokModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Malzemeye Stok Girişi Yap</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="stok-adding">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Stok Ekleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="form-group row">
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-kod">Stok Kodu</label>
                    <input type="text" readonly class="form-control" id="malzeme-kod"
                      :value="selectedMalzeme.MALZEME_CODE">
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-name">Ürün Adı</label>
                    <input type="text" readonly class="form-control" id="malzeme-name"
                      :value="selectedMalzeme.MALZEME_NAME">
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="add-qty">Eklenecek Miktar</label>
                    <input type="text" class="form-control" v-model="additionQuantityToStok" id="add-qty">
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-tur">Yeni Stok Miktarı</label>
                    <input type="text" readonly class="form-control"
                      :value="parseInt(selectedMalzeme.MALZEME_LENOI) + parseInt(additionQuantityToStok)" id="malzeme-tur">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="addStokToMalzeme()" class="btn btn-primary">Stok Girişini Tamamla</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canSpendStok" class="modal fade bd-example-modal-lg" id="exportFabrikaModal" tabindex="-1"
      role="dialog" aria-labelledby="exportFabrikaModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Fabrikaya Malzeme Çıkışı Yap</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="stok-adding">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Fabrikaya Çıkış Yapılıyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="form-group row">
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-kod">Stok Kodu</label>
                    <input type="text" readonly class="form-control" id="malzeme-kod"
                      :value="selectedMalzeme.MALZEME_CODE">
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-name">Ürün Adı</label>
                    <input type="text" readonly class="form-control" id="malzeme-name"
                      :value="selectedMalzeme.MALZEME_NAME">
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="add-qty">Çıkış Yapılacak Miktar</label>
                    <input type="text" class="form-control" v-model="additionQuantityToStok" id="add-qty">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-tur">Yeni Fabrika Stok Miktarı</label>
                    <input type="text" readonly class="form-control"
                      :value="parseInt(selectedMalzeme.MALZEME_FABRIKA) + parseInt(additionQuantityToStok)" id="malzeme-tur">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-tur">Yeni Toplam Stok Miktarı</label>
                    <input type="text" readonly class="form-control"
                      :value="parseInt(selectedMalzeme.MALZEME_LENOI) - parseInt(additionQuantityToStok)" id="malzeme-tur">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="exportStok(0)" class="btn btn-primary">Fabrika Çıkışını Tamamla</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canSpendStok" class="modal fade bd-example-modal-lg" id="exportUmeModal" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Ürün Montaja Malzeme Çıkışı Yap</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="stok-adding">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Fabrikaya Çıkış Yapılıyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="form-group row">
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-kod">Stok Kodu</label>
                    <input type="text" readonly class="form-control" id="malzeme-kod"
                      :value="selectedMalzeme.MALZEME_CODE">
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-name">Ürün Adı</label>
                    <input type="text" readonly class="form-control" id="malzeme-name"
                      :value="selectedMalzeme.MALZEME_NAME">
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="add-qty">Çıkış Yapılacak Miktar</label>
                    <input type="text" class="form-control" v-model="additionQuantityToStok" id="add-qty">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-tur">Yeni Ürün Montaj Stok Miktarı</label>
                    <input type="text" readonly class="form-control"
                      :value="parseInt(selectedMalzeme.MALZEME_URUNMONTAJ) + parseInt(additionQuantityToStok)" id="malzeme-tur">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-tur">Yeni Toplam Stok Miktarı</label>
                    <input type="text" readonly class="form-control"
                      :value="parseInt(selectedMalzeme.MALZEME_LENOI) - parseInt(additionQuantityToStok)" id="malzeme-tur">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="exportStok(1)" class="btn btn-primary">Ürün Montaja Malzeme Çıkışını Tamamla</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canDeleteStok" class="modal fade bd-example-modal-lg" id="deleteMalzemeModal" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Aşağıda bilgileri yer alan malzemeyi silmek istediğinizden emin misiniz ?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="malzeme-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Malzeme Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-kod">Stok Kodu</label>
                    <input type="text" readonly class="form-control" id="malzeme-kod"
                      :value="selectedMalzeme.MALZEME_CODE">
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-name">Ürün Adı</label>
                    <input type="text" readonly class="form-control" id="malzeme-name"
                      :value="selectedMalzeme.MALZEME_NAME">
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="add-qty">Lenoi Stok</label>
                    <input type="text" class="form-control" readonly :value="selectedMalzeme.MALZEME_LENOI" id="add-qty">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-fabrika">Fabrika Stok</label>
                    <input type="text" readonly class="form-control" :value="selectedMalzeme.MALZEME_FABRIKA" id="malzeme-fabrika">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-ume">Ürün Montaj Ekibi Stok</label>
                    <input type="text" readonly class="form-control" :value="selectedMalzeme.MALZEME_URUNMONTAJ" id="malzeme-ume">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteMalzeme()" class="btn btn-danger">Malzemeyi Sil</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canReadMessage" class="modal fade bd-example-modal-lg" id="conversationModal" tabindex="-1" role="dialog" aria-labelledby="conversationModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-lg">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">İşlem Geçmişi</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="conversation-body-messages" class="modal-body modal-body-fixed">
            <v-wait for="mesajlar-loading">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Mesajlar yükleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row mb-4" :id="'message-row' + index" v-for="(message, index) in activeMessages" :key="message.MESSAGE_ID">
                  <div class="col-md-12">
                    <div class="bubble clearfix" v-bind:class="{'own text-right' : message.PERSONEL_ID == getPersonelId}">
                      <span class="my-0" v-bind:class="{'float-right' : message.PERSONEL_ID == getPersonelId}">{{message.MESSAGE_TEXT}}</span>
                      <small class="text-muted mt-1"
                        v-bind:class="{'float-right' : message.PERSONEL_ID == getPersonelId, 'float-left': message.PERSONEL_ID != getPersonelId}" >
                        {{message.MESSAGE_DATE}} - {{message.PERSONEL_NAME}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <div class="input-group">
              <textarea class="form-control" :disabled="!canWriteMessage" placeholder="Notunuzu buraya yazın..." v-model="malzemeMessageText"
                aria-label="Notunuzu buraya yazın..." aria-describedby="button-addon2"></textarea>
              <div class="input-group-append">
                <button class="btn btn-primary" :disabled="!canWriteMessage" @click="insertMalzemeMesaji()" type="button" id="button-addon2">Notu Ekle</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canAddSerialNumberToMalzeme" class="modal fade bd-example-modal-lg" id="addSerialNumbersModal" tabindex="-1"
      role="dialog" aria-labelledby="addSeriailNumbersModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Seri Numarası Girişi Yap</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="stok-adding">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Seri Numaraları Ekleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="form-group row">
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-kod">Stok Kodu</label>
                    <input type="text" readonly class="form-control" id="malzeme-kod"
                      :value="selectedMalzeme.MALZEME_CODE">
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-name">Ürün Adı</label>
                    <input type="text" readonly class="form-control" id="malzeme-name"
                      :value="selectedMalzeme.MALZEME_NAME">
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="add-serial-numbers">Seri Numaraları Listesi&nbsp;&nbsp;&nbsp;<span class="text-muted">{{serialCountToAdd}} adet seri numarası eklenmeye hazır</span></label>
                    <textarea class="form-control" rows="10" v-model="serialNumbers" id="add-serial-numbers"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="addSerialsToMalzeme()" class="btn btn-primary">Seri Numaralar Girişini Tamamla</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'StokPage',
  data () {
    return {
      searchFilter: "",
      malzemeler: [],
      formVisible: false,
      selectedMalzemeId: -1,
      selectedMalzemeIndex: -1,
      selectedMalzeme: {
        SESSION_ID: '',
        MALZEME_CODE: '',
        MALZEME_COUNT: '',
        MALZEME_CREATED: '',
        MALZEME_CREATOR: '',
        MALZEME_DETAIL: '',
        MALZEME_FABRIKA: 0,
        MALZEME_ID: 0,
        MALZEME_KALAN: 0,
        MALZEME_LASTMODIFIED: '',
        MALZEME_LENOI: 0,
        MALZEME_MANCODE: '',
        MALZEME_MANUFACTURER: '',
        MALZEME_NAME: '',
        MALZEME_NOTE: '',
        MALZEME_SUPPLIER: '',
        MALZEME_TYPE: '',
        MALZEME_UNIT_PRICE: '',
        MALZEME_URUNMONTAJ: 0
      },
      backupMalzeme: {
        SESSION_ID: '',
        MALZEME_CODE: '',
        MALZEME_COUNT: '',
        MALZEME_CREATED: '',
        MALZEME_CREATOR: '',
        MALZEME_DETAIL: '',
        MALZEME_FABRIKA: 0,
        MALZEME_ID: 0,
        MALZEME_KALAN: 0,
        MALZEME_LASTMODIFIED: '',
        MALZEME_LENOI: 0,
        MALZEME_MANCODE: '',
        MALZEME_MANUFACTURER: '',
        MALZEME_NAME: '',
        MALZEME_NOTE: '',
        MALZEME_SUPPLIER: '',
        MALZEME_TYPE: '',
        MALZEME_UNIT_PRICE: '',
        MALZEME_URUNMONTAJ: 0
      },
      additionQuantityToStok: 0,
      malzemeMessageText: null,
      viewConversation: false,
      activeMessages: [],
      openModalFor: 0,
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
      columnOptions: {
        MALZEME_MANUFACTURER: false,
        MALZEME_MANCODE: false,
        MALZEME_SUPPLIER: false,
        MALZEME_UNIT_PRICE: false,
        MALZEME_NOTE: false,
        MALZEME_CREATOR: false,
        MALZEME_CREATED: false
      },
      serialNumbers: ''
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canViewStok : function() { return this.$store.getters.userCanViewStok },
    canAddStok : function() { return this.$store.getters.userCanAddStok },
    canSpendStok : function() { return this.$store.getters.userCanSpendStok },
    canDeleteStok : function() { return this.$store.getters.userCanDeleteStok },
    canReadMessage : function() { return this.$store.getters.userCanReadMessage },
    canWriteMessage : function() { return this.$store.getters.userCanWriteMessage },
    canAddSerialNumberToMalzeme: function() { return true; },
    serialCountToAdd : function() { return this.serialNumbers.split('\r\n').filter(m => m.length == 15).length; }
  },
  methods: {
    selectMalzeme(malzemeId, malzemeIndex){
      this.selectedMalzeme = this.malzemeler[malzemeIndex]
      this.selectedMalzemeId = this.selectedMalzeme.MALZEME_ID
      this.selectedMalzemeIndex = malzemeIndex
    },
    openAddStokModal(malzemeId, malzemeIndex) {
      if(this.selectedMalzeme == malzemeId)
        return

      this.selectMalzeme(malzemeId, malzemeIndex)
    },
    openExportFabrikaModal(malzemeId, malzemeIndex) {
      if(this.selectedMalzeme == malzemeId)
        return

      this.selectMalzeme(malzemeId, malzemeIndex)
    },
    openExportUmeModal(malzemeId, malzemeIndex) {
      if(this.selectedMalzeme == malzemeId)
        return

      this.selectMalzeme(malzemeId, malzemeIndex)
    },
    askDelete(malzemeId, malzemeIndex) {
      if(this.selectedMalzeme == malzemeId)
        return

      this.selectMalzeme(malzemeId, malzemeIndex)
    },
    getMalzemeler() {
      this.$wait.start('malzemeler-loading')
      let sessionid = localStorage.getItem('utks-sessionid')
      axios.post('/api/stok/tum-malzemeler?sessionid=' + sessionid + '&searchFilter=' + this.searchFilter,
        { 'SessionId': sessionid, 'SearchFilter': this.searchFilter })
      .then(response => {
        this.malzemeler = response.data
        this.$wait.end('malzemeler-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('malzemeler-loading')
      })
    },
    insertMalzeme() {
      this.$wait.start('malzeme-inserting')
      this.selectedMalzeme.SESSION_ID = this.getSessionId
      axios.post('/api/stok/malzeme-olustur', this.selectedMalzeme)
      .then(response => {
        this.$toasted.success('Malzeme oluşturuldu.', this.toastOptions)
        this.formVisible = false
        this.getMalzemeler()
      })
      .catch(error => {
        this.$toasted.error('Malzeme oluşturulamadı. Durum mesajı: ' + error.response.data.ErrorMessage, this.toastOptions)
      })

      this.$wait.end('malzeme-inserting')
      $("#addMalzemeModal").modal('hide')
    },
    deleteMalzeme() {
      this.$wait.start('malzeme-deleting')
      let sessionid = localStorage.getItem('utks-sessionid')
      let deleteJson = {}
      deleteJson.SessionId = sessionid;
      deleteJson.MalzemeId = this.selectedMalzemeId

      console.log(deleteJson)
      axios.post('/api/stok/malzeme-sil', deleteJson)
      .then(response => {
        this.$toasted.success('Malzeme silindi.', this.toastOptions)
        this.getMalzemeler()
      })
      .catch(error => {
        this.$toasted.error('Malzeme silinemedi. Durum mesajı: ' + error.data.ErrorMessage, this.toastOptions)
        console.error(error)
      })

      this.$wait.end('malzeme-deleting')
      $("#deleteMalzemeModal").modal('hide')
    },
    addStokToMalzeme() {
      this.$wait.start('stok-adding')
      let sessionid = localStorage.getItem('utks-sessionid')
      let addJson = {}
      addJson.SessionId = sessionid
      addJson.MalzemeId = this.selectedMalzemeId
      addJson.Addition = this.additionQuantityToStok
      axios.post('/api/stok/malzeme-ekle', addJson)
      .then(response => {
        if(response.data.HasError == false) {
          this.$toasted.success('Stok girişi yapıldı.', this.toastOptions)
          this.getMalzemeler()
        }
        else
          this.$toasted.error('Stok girişi yapılamadı. Durum mesajı: ' + response.data.ErrorMessage)
        
        this.additionQuantityToStok = 0
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('stok-adding')
      })

      this.$wait.end('stok-adding')
      $("#addStokModal").modal('hide')
    },
    exportStok(exportType) {
      this.$wait.start('stok-exporting')
      let sessionid = localStorage.getItem('utks-sessionid')
      let addJson = {}
      addJson.SessionId = sessionid
      addJson.MalzemeId = this.selectedMalzemeId
      addJson.Quantity = this.additionQuantityToStok
      addJson.SpentType = exportType
      axios.post('/api/stok/malzeme-cikar', addJson)
      .then(response => {
        if(response.data.HasError == false) {
          this.$toasted.success('Stok çıkışı yapıldı.', this.toastOptions)
          this.getMalzemeler()
        }
        else
          this.$toasted.success('Stok çıkışı yapılamadı. Durum mesajı: ' + response.data.ErrorMessage, this.toastOptions)

        this.additionQuantityToStok = 0
      })
      .catch(error => { 
        console.error(error) 
      })

      this.$wait.end('stok-exporting')
      $("#exportUmeModal").modal('hide')
      $("#exportFabrikaModal").modal('hide')
    },
    insertMalzemeSerialNumbers() {
      
    },
    openMalzemeMesajlari(malzemeId, malzemeIndex) {
      console.log(this.getPersonelId == 3);
      if(this.selectedMalzemeId == malzemeId && this.viewConversation == true) {
        this.viewConversation = false
        return
      }

      this.selectMalzeme(malzemeId, malzemeIndex)
      this.viewConversation = true
      this.getMalzemeMesajlari()
    },
    getMalzemeMesajlari() {
      this.$wait.start('mesajlar-loading');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.ArizaId = this.selectedMalzemeId

      axios
      .post('/api/stok/get-mesajlar', getJson)
      .then(response => {
        this.activeMessages = response.data
        this.$wait.end('mesajlar-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('mesajlar-loading')
      })
    },
    insertMalzemeMesaji() {
      if(!this.malzemeMessageText)
        return

      this.$wait.start('mesaj-insert');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.ArizaId = this.selectedMalzemeId
      getJson.MessageText = this.malzemeMessageText

      axios
      .post('/api/stok/mesaj-ekle', getJson)
      .then(response => {
        this.$wait.end('mesaj-insert')
        this.malzemeMessageText = null
        this.getMalzemeMesajlari()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('mesaj-insert')
      })
    },
    openModalForInsertUpdate(type, index) {
      this.openModalFor = type
      if(type == 1)
        this.selectMalzeme(0, index)
      else {
        this.selectedMalzeme = this.backupMalzeme
        this.selectedMalzemeId = 0
        this.selectedMalzemeIndex = -1
      }
    },
    formatNote(title) {
      if(title && title.length > 40)
        return title.substring(0, 37) + "..."
      else return title
    },
  },
  mounted() {
    this.getMalzemeler()
  }
}
</script>

<style scoped>

  .table-bordered{
    border-color: #F7F7F7
  }

  table, .dropdown-item {
    font-size: .875rem;
  }

  .thead-fixed {
    position: fixed;
    z-index: 1;
    top: 60px;
    left: 0;
    right: 0;
    width: 100%;
    table-layout: fixed;
    display: table; 
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  td .btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .font-light {
    font-weight: 400 !important;
  }

  .font-light:first-child {
    margin-left: -1px;
  }

</style>


// WEBPACK FOOTER //
// src/components/StokPage.vue